import _ from 'lodash';

import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError } from '../../../shared/notify';
import fetch from '../../fetch';
import { fetchBlob } from '../../fetchBlob';
import moment from "moment";
import { ExportFormatEnum } from '../types/export-format.enum';

const themes = (() => {
    const _success = function(res, req) {
        if (!_.size(res) || !_.some(res, r => r.valor !== 0)) {
            const message = {
                type: NOTIFY_TYPE.LOG,
                text: 'Não existem dados para o filtro selecionado'
            };
            notifyError(null, message);
        }

        const mapData = (f, key) => ({
            idLocalidade: key,
            value: _.sumBy(f, 'valor'),
            values: f
        });

        const mapInvasion = (f, key) => {
            const totalDealers = _.sumBy(f, 'totalDealer');
            return {
                idLocalidade: key,
                value: (f[0].totalIndustry - (totalDealers || 0)) / f[0].totalIndustry,
                totalDealers,
                values: f
            };
        };

        const mapSocialClass = (f, key) => ({
          idLocalidade: key,
          value: f[0].valor,
          values: f
        });

        const mapPib = (f, key) => ({
          idLocalidade: key,
          value: f[0].valor,
          values: f
        });

        const dictMapper = {
          20: mapInvasion,
          26: mapSocialClass,
          27: mapPib
        };

        const mapResponse = dictMapper[req.idTema] ? dictMapper[req.idTema] : mapData;
        const groupByLocale = _(res)
            .groupBy(f => f.idLocalidade)
            .map(mapResponse)
            .value();

        const output = {
            consolidate: {},
            detailed: {}
        };

        _.forEach(groupByLocale, value => {
            if (isNaN(value.value)) {
              value.values.valor = value.value;
              output.consolidate[value.idLocalidade] = value.value;
              output.detailed[value.idLocalidade] = value.values;
            } else {
              const valCalculate = (Number(value.value) * 100).toFixed(2) / 100;
              value.values.valor = valCalculate;
              output.consolidate[value.idLocalidade] = valCalculate;
              output.detailed[value.idLocalidade] = value.values;
            }
        });

        return output;
    };

    const get = {
        area: {},
        areas: {},
        voronoi: {},
    };

    const request = (
        url,
        { then = res => res, mapUrl = null, hasHeader = true, method = 'POST' } = { then: res => res, method: 'POST' }
    ) => req =>
        fetch({
            type: method,
            url: `${ environment.get('API_HOST')}/${!!mapUrl ? mapUrl(req) : url }`,
            header: hasHeader && {
                'X-UIKey': 'dynamic-maps-layers'
            },
            data: method === 'POST' ? JSON.stringify(req) : req,
            error: notifyError
        }).then(res => then(res, req));

    const requestSales = request('MapaDinamico/ObterDadosLocalidades', { then: _success });

    get.area.sales = requestSales;

    get.areas.salesExport = req => {
        req.format = new ExportFormatEnum().blob;
        return fetchBlob({
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            fileName:`${environment.get('CONFIG.CLIENT')}_Painel de Dados_Limites_Territoriais_v${moment().format('YYYYMMDD')}.xlsx`,
            url: `${environment.get('API_HOST')}/MapaDinamico/GetSalesExportMap`,
            parameters: req,
            error: notifyError
        });
    };

    get.areas.directSales = request('MapaDinamico/GetDirectSalesMap');

    get.areas.customers = request('MapaDinamico/GetCustomersByLocale');

    get.areas.directSalesExport = req =>
        fetchBlob({
            fileName: `${environment.get('CONFIG.CLIENT')}_Painel de Dados_Venda Direta_v${moment().format('YYYYMMDD')}.xlsx`,
            type: 'POST',
            url: `${environment.get('API_HOST')}/MapaDinamico/GetDirectSalesExportMap`,
            parameters: req
        }).catch(notifyError);

    get.clusterSales = request('lojaconcessionaria/obterdadosclustervendas', { method: 'POST', hasHeader: false });

    get.mallCenters = request('lojaconcessionaria/getmallcenterswithstores', { method: 'POST', hasHeader: false });

    get.areas.exportAutoParts = req =>
        fetchBlob({
            fileName: `${environment.get('CONFIG.CLIENT')}_${req.Type}_${req.Title}_Oficinas e Autopeças_v${moment().format('YYYYMMDD')}.xlsx`,
            type: 'POST',
            url: `${environment.get('API_HOST')}/MapaDinamico/getautopartsexport?idLocale=${req.IdLocale}`,
        }).catch(notifyError);

    return {
        get
    };
})();

export default themes;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/themes/index.js